export const RESPONSE_STATUS_OK = 200
export const RESPONSE_STATUS_CREATED = 201
export const RESPONSE_STATUS_NO_CONTENT = 204
export const RESPONSE_STATUS_BAD_REQUEST = 400
export const RESPONSE_STATUS_NOT_FOUND = 404
export const RESPONSE_STATUS_CONFLICT = 409
export const RESPONSE_STATUS_UNPROCESSABLE_CONTENT = 422
export const RESPONSE_STATUS_UNAUTHORIZED = 401
export const RESPONSE_STATUS_TEAPOT = 418
